import { cx } from '@linaria/core';
import { useId } from 'react';
import { TranscriptButton } from '@pm2/element-toolbar';
import { usePm2Modal } from '@pm2/ui-lightbox';
import { units, resets } from '@ui/css';
import { Button, PM2ImageIcon } from '@ui/kit';
import { printHtmlNodesToJsx } from '@utils/ast';
import { preloadImage } from '@utils/common';
import { UniversalContextMenu } from '@utils/component-framework';
import { PostloadedImage } from '@utils/react';
import { usePageContext } from '../../context.js';
import { tokens, modal, contextMenu, image, imageWrapper } from './image.style.js';
import { media } from './shared.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function ImageMedia(props) {
  const modal$1 = usePm2Modal();
  const context = usePageContext();
  if (context !== "print" && props.node.showInLightbox) {
    const onClick = () => {
      modal$1.fromContent((async () => {
        const img = await preloadImage(props.node.src);
        return /*#__PURE__*/jsx("div", {
          className: modal,
          style: tokens.__override({
            aspect: `${img.naturalWidth} / ${img.naturalHeight}`,
            height: units.px(img.naturalHeight),
            width: units.px(img.naturalWidth)
          }),
          children: /*#__PURE__*/jsx(ImageComponent, {
            ...props,
            sizes: "100vw",
            width: img.naturalWidth,
            height: img.naturalHeight
          })
        });
      })(), {
        speechFile: undefined
      });
    };
    return /*#__PURE__*/jsx(Button, {
      theme: "primary",
      icon: /*#__PURE__*/jsx(PM2ImageIcon, {
        height: 16
      }),
      onClick: onClick,
      children: "Vis billede i lightbox"
    });
  } else {
    return /*#__PURE__*/jsx(ImageComponent, {
      ...props
    });
  }
}
function ImageComponent(props) {
  const pageContext = usePageContext();
  const id = useId();
  return /*#__PURE__*/jsxs("div", {
    className: cx(media, imageWrapper),
    children: [pageContext !== "print" && !!props.node.longDescription?.length && /*#__PURE__*/jsx("div", {
      className: contextMenu,
      children: /*#__PURE__*/jsx(UniversalContextMenu, {
        layout: "solid",
        label: "\xC5bn kontekstmenuen",
        children: /*#__PURE__*/jsx(TranscriptButton, {
          nodeType: "image-component",
          transcript: props.node.longDescription
        }, "transcript")
      })
    }), /*#__PURE__*/jsx(PostloadedImage, {
      className: image,
      alt: props.node.altText ?? "",
      src: props.node.src,
      width: props.width,
      height: props.height,
      "aria-details": props.node.longDescription.length ? `transcript-${id}` : undefined,
      "data-page-context": pageContext
      // Due to legacy constraints we must render images in their natural
      // dimensions (up to a max), even on retina screens, even though this
      // causes blurred images.
      // See ADO #125911
      ,
      onReady: img => {
        const aspect = img ? img.naturalWidth / img.naturalHeight : 1;
        img?.style.setProperty("width", `${Math.min(350, img.naturalHeight) * aspect}px`);
      }
    }), pageContext !== "print" && !!props.node.longDescription.length && /*#__PURE__*/jsx("div", {
      className: resets.screenReaderOnlyCls,
      id: `transcript-${id}`,
      children: printHtmlNodesToJsx(props.node.longDescription)
    })]
  });
}

export { ImageComponent, ImageMedia };
//# sourceMappingURL=image.js.map
